'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var doesContainActiveElement = function doesContainActiveElement(el) {
  return (el === null || el === void 0 ? void 0 : el.contains) && el.contains(document.activeElement);
};

exports.doesContainActiveElement = doesContainActiveElement;
//# sourceMappingURL=utils.js.map
